import React from "react";
import Monitoring from "../monitoring";

/**
 * RPMMonitoringPanel — inner section inside the merged right-column card.
 *
 * Layout-pass scope (TH-A1): wraps the existing <Monitoring /> component
 * with a chatBotType-aware title and the inlineActions flag so the
 * time-options + spinner controls render below the title instead of
 * overflowing the CollapsableSection header in the narrow right column.
 *
 * The card chrome (shadow, radius) is provided by the parent `.rightCard`
 * wrapper in DetailsTab. TH-A5 will replace the inner UX with pill
 * toggles + live timer integration.
 */
const RPMMonitoringPanel = ({
  chatBotType,
  sessionId,
  ccmSessionId,
  resetTimer,
  isOpen,
  onClose,
  defaultTimer,
  noteToPaste,
}) => {
  const title = chatBotType === "CCM" ? "CCM Monitoring" : "RPM Monitoring";

  return (
    <Monitoring
      title={title}
      inlineActions={true}
      chatBotType={chatBotType}
      sessionId={sessionId}
      ccmSessionId={ccmSessionId}
      resetTimer={resetTimer}
      isOpen={isOpen}
      onClose={onClose}
      defaultTimer={defaultTimer}
      noteToPaste={noteToPaste}
    />
  );
};

export default RPMMonitoringPanel;
